import React, { FunctionComponent, useState } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import LoaderButton from '../../../components/loaderButton'
import { displayDollars } from '../../../helpers/displayFormatHelper'
import LoanOverviewRow from './loanOverviewRow'
import { selectCurrentRefi, selectCurrentTradeline } from '../../../reducers'
import { Refi, RefiTradeline } from '../types'
import { Callback } from '../../../utils/types'
import dateHelpers from '../../../helpers/dateHelpers'
import {
  updateRefi,
  createRefiProducts,
  setRefiAppCreditStepState,
} from '../refiActions'

export interface Props {
  refi: Refi
  tradeline: RefiTradeline
  updateRefi: Callback<Promise<any>>
  createRefiProducts: Callback<Promise<any>>
  setRefiAppCreditStepState: Callback
}

const formatMonths = (value: any) => {
  return `${String(value)} months`
}

export const LoanOverview: FunctionComponent<Props> = ({
  refi,
  tradeline,
  updateRefi,
  createRefiProducts,
  setRefiAppCreditStepState,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const onClickSubmit = () => {
    setIsLoading(true)
    const refiParams = {
      id: refi.id,
      cash_back_amount: refi.cash_back_amount,
      existing_values: true,
    }
    updateRefi(refiParams)
      .then(() => createRefiProducts({ id: refi.id }))
      .then(() => setRefiAppCreditStepState('MembershipAndGapProduct'))
      .catch(() => setIsLoading(false))
  }

  return (
    <div className="form form--with-border loan-details">
      <p className="loan-details__subtitle">
        Your existing loan with {tradeline.institution}
      </p>
      <LoanOverviewRow
        title="Monthly payment"
        value={displayDollars(tradeline.payment)}
      />
      <LoanOverviewRow
        title="Principal balance"
        value={displayDollars(tradeline.balance)}
      />
      <LoanOverviewRow title="Loan term" value={formatMonths(tradeline.term)} />
      <LoanOverviewRow
        title="Estimated term remaining"
        value={formatMonths(
          Number(tradeline.remaining) ||
            dateHelpers.calculateTimeRemaining(
              tradeline.term,
              tradeline.origination_date
            )
        )}
      />
      <LoanOverviewRow
        title='Estimated Annual Percentage Rate ("APR")'
        value={`${numeral(tradeline.apr).format('0,0.0000')}%`}
      />

      <div className="form__group refi-app__form-buttons">
        <LoaderButton
          type="button"
          className="button button-drive-america"
          data-testid="confirmLoan"
          onClick={onClickSubmit}
          isLoading={isLoading}
        >
          Confirm
        </LoaderButton>
      </div>
    </div>
  )
}

export const mapStateToProps = (state) => ({
  refi: selectCurrentRefi(state),
  tradeline: selectCurrentTradeline(state),
})

export default connect(mapStateToProps, {
  updateRefi,
  createRefiProducts,
  setRefiAppCreditStepState,
})(LoanOverview)
